import { formatter, request } from "@/utils/request";

export namespace RebateInfo {
  export const Path = {
    QueryForSelect: '/reportapi/rebateInfo/queryForSelect'
  }
  export async function queryForSelect(body: API.QueryForPageReq) {
    const options = {
      method: 'POST',
      body: {
        ...body
      }
    };
    return request<API.QueryResult<any>>(Path.QueryForSelect, formatter(options));
  }

}

export namespace RebatePolicy {
  export const Path = {
    QueryForSelect: '/reportapi/rebatePolicy/queryForSelect',
  }
  export async function queryForSelect(body: API.QueryForPageReq) {
    const options = {
      method: 'POST',
      body: {
        ...body
      }
    };
    return request<API.QueryResult<any>>(Path.QueryForSelect, formatter(options));
  }
}
